/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $('.ad_to_cart_coll').click(function(){    
//   var ID = $(this).attr("data-var_id");
//   addItemToCart( ID, 1);   // paste your id product number
//   $('.cart_dr').trigger( "click" );
// });
// function addItemToCart(variant_id, qty) {
//   data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() { 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true  //this code is for prestige theme, is to refresh the cart
//       }));
//     }   
    
//   }); 
 
// }

/* quick add to cart buttons for drawer - collection/product pages */
jQuery(document).ready(function($){  
  
  $('body').on('click','.Button_ATC',function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $('.PageOverlay').addClass('is-visible');
    var id = $(this).attr('data-var_id'); 
    var i = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: { id: id, quantity: i },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);            
      },
      success: function() {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: id,
            quantity: 1
          }
        }));
        // $.get( "/cart?view=drawer", function( data ) {               
        //   $('#sidebar-cart .Drawer__Content').html($(data).find('.Drawer__Content').html());    
        // });
        // $('#sidebar-cart').attr('aria-hidden','false');
        // $.getJSON('/cart.js', function(cart){
        //   $('.Header__CartCount').text(cart.item_count);
        // });
      }         
    });
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
  /* slider for thumbnails - product pages */
  if($(window).width() > 1140){
    $('.Product__SlideshowNavScroller').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1
    });
  }
})


/* main header drop down for international - redirects to other sites */
  $(function(){
    $('.region').change(function(){
      if ( $(this).val() == 'au' ) {
      {
    	window.location = "https://www.kleankanteen.com.au";
      }
      }
      else if ( $(this).val() == 'be' ) {
      {
    	window.location = "https://www.kleankanteen.be";
      }
      }
      else if ( $(this).val() == 'ca' ) {
      {
    	window.location = "https://www.kleankanteen.com/pages/store-locator-canada";
      }
      }
      else if ( $(this).val() == 'cl' ) {
      {
    	window.location = "https://www.kleankanteen.cl";
      }
      }
      else if ( $(this).val() == 'cr' ) {
      {
    	window.location = "https://www.kleankanteen.co.cr";
      }
      }
      else if ( ($(this).val() == 'de' ) || ($(this).val() == 'at' )) {  
      {
    	window.location = "https://www.kleankanteen.de";
      }
      }
      else if ( $(this).val() == 'fr' ) {
      {
    	window.location = "https://www.kleankanteen.be";
      }
      }
      else if ( ($(this).val() == 'es' ) || ($(this).val() == 'pt' )) {  
      {
    	window.location = "https://www.kleankanteen.es";
      }
      }
      else if ( $(this).val() == 'jp' ) {
      {
    	window.location = "https://www.kleankanteen.jp";
      }
      }
      else if ( $(this).val() == 'kr' ) {
      {
    	window.location = "https://www.kleankanteen.co.kr";
      }
      }
      else if ( $(this).val() == 'lu' ) {
      {
    	window.location = "https://www.kleankanteen.be";
      }
      }
      else if ( $(this).val() == 'mx' ) {
      {
    	window.location = "https://www.kleankanteen.com/pages/store-locator-mexico";
      }
      }
        else if ( $(this).val() == 'my' ) {
      {
    	window.location = "https://certifiedcalm.com/collections/klean-kanteen-1/Insulated-Bottle";
      }
      }
      else if ( $(this).val() == 'nz' ) {
      {
    	window.location = "https://www.kleankanteen.co.nz";
      }
      }
        else if ( $(this).val() == 'nl' ) {
      {
    	window.location = "https://www.kleankanteen.be";
      }
      }
      else if ( $(this).val() == 'ph' ) {
      {
    	window.location = "https://certifiedcalm.com/collections/klean-kanteen-1/Insulated-Bottle";
      }
      }
      else if ( ($(this).val() == 'sg' ) || ($(this).val() == 'my' )) {
      {
    	window.location = "https://www.kleankanteen.com/pages/store-locator-singapore";
      }
      }
      else if ( ($(this).val() == 'gb' ) || ($(this).val() == 'ie' )) {
      {
    	window.location = "https://www.kleankanteen.co.uk";
      }
      }
      else if ( $(this).val() == 'ru' ) {
      {
    	window.location = "https://www.kleankanteen.ru.com";
      }
      }
      else if ( $(this).val() == 'se' ) {
      {
    	window.location = "https://www.kleankanteen.se";
      }
      }
      else if ( $(this).val() == 'th' ) {
      {
    	window.location = "https://shopprogression.com/klean-kanteen";
      }
      }
      else if ( $(this).val() == 'tw' ) {
      {
    	window.location = "https://www.kleankanteentw.com";
      }
      }
      else if ( $(this).val() == 'za' ) {
      {
    	window.location = "http://www.awesometools.co.za/brands/klean-kanteen/";
      }
      }
  	});
  });
/* lazyload embedded youtube videos with custom thumbs */
$(function() {

    var youtube = document.querySelectorAll( ".youtube" );
    
    for (var i = 0; i < youtube.length; i++) {
        
        var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
        
        var image = new Image();
                image.src = source;
                image.alt = 'Play Klean Kanteen YouTube Video';
                image.title = 'Play Klean Kanteen YouTube Video';
                image.addEventListener( "load", function() {
                    youtube[ i ].appendChild( image );
                }( i ) );
        
                youtube[i].addEventListener( "click", function() {

                    var iframe = document.createElement( "iframe" );

                            iframe.setAttribute( "frameborder", "0" );
                  			iframe.setAttribute( "title", "Play Klean Kanteen Video" );
                            iframe.setAttribute( "allowfullscreen", "" );
							iframe.setAttribute( "allow", "autoplay" );                            
                            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

                            this.innerHTML = "";
                            this.appendChild( iframe );
                } );    
    };
    
});

/* Avantlink affiliate - sitewide script */
$(function() {
var avm = document.createElement('script'); avm.type = 'text/javascript'; avm.async = true;
avm.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.avmws.com/1019701/';
var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(avm, s);
});











theme.isStorageSupported = function(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.hasLocalStorage = theme.isStorageSupported('local');

// 
theme.regionModal = function() {
    
  //configuration settings
  const regionConfig = {
    storeLinkQueryParameter: 'setstore',
    modalID: "regionModal",
    modalVersion: 1,
  }
  
  //key for localStorage based on version
  const lsStorageKey = 'kleen-kanteen-store-v'+regionConfig.modalVersion;

  console.log(lsStorageKey);
  
  // var regionModal = new theme.Modals(regionConfig.modalID, 'region-modal', {
  //   closeOffContentClick: true,
  //   solid: false
  // });
  
  
  //function to retrieve named parameter from URL
  function getQueryParameter(name){
    if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
      return decodeURIComponent(name[1]);
  }
  
  
  function showModalOnLoad() {
    //PROCESSING LOGIC FOR DETECTING WHETHER USER HAS SET A STORE OR NOT
    
    //can user support localstorage - if not, return (don't do anything)
    if(!theme.hasLocalStorage) return false;
    
    //has user been geolocated before on this storefront
    // const currentCode = window.localStorage.getItem(lsStorageKey);
    // if(currentCode && currentCode == storeCode) {
    //   return false;
    // }
    
    //does current request contain a reference that the user has set their location themeselves?
    // const userSetLocale = getQueryParameter(regionConfig.storeLinkQueryParameter);
    // if(userSetLocale == 1) {
    //   window.localStorage.setItem(lsStorageKey, storeCode);
    //   return false;
    // }
    

    //for testing, allow user to pass a location (us, ca, uk etc)
    var userLocation = getQueryParameter('location');
    var userCountry = "";

    if(userLocation !== undefined) {
      showModal(userLocation, userLocation);
    } else {
      //get the country code of the user from: https://ip.nf/me.json
      fetch('https://ip.nf/me.json')
      .then(
        function(response) {
          if (response.status !== 200) {
            return false;
          }
          // Examine the text in the response
          response.json().then(function(data) {
            //TODO - handle when data or data.ip or data.ip.country_code is undefined
            userLocation = data.ip.country_code.toLowerCase();
            userCountry = data.ip.country.toLowerCase();
            showModal(userLocation, userCountry);
          });
        }
      ).catch(function(err) {
        return false;
      });
    }
    
    return true;
    
  }

  function showModal(userLocation, userCountry) {

    // default to US store
    const storeCode = (typeof(window.storeCode) != "undefined") ? window.storeCode : 'us';
    // has user been geolocated before on this storefront
    const currentCode = window.localStorage.getItem(lsStorageKey);

    console.log(storeCode+' - '+currentCode+' - '+userLocation);

    window.localStorage.setItem(lsStorageKey, userLocation);

    if(userLocation == storeCode || userLocation == currentCode) {
      //they are in the USA or have already seen the popup
      return false;
    }
    //otherwise pop open the modal and let the user choose
    //regionModal.open();
    //alert("MODAL")
    //set localstorage in case they close the modal without selecting
    //we assume this implies they accept their location
    //window.localStorage.setItem(lsStorageKey, storeCode);

    
    var showModal = false;
    var countryText = userCountry;
    var notFoundText = "";
    var redirect = "";
    switch(userLocation) {
      case 'at':
        showModal = true;
        countryText = "Austria";
        redirect = "https://www.kleankanteen.de";
        break;
      case 'au':
        showModal = true;
        countryText = "Australia";
        redirect = "https://www.kleankanteen.com.au";
        break;
      case 'be':
        showModal = true;
        countryText = "Belgium";
        redirect = "https://www.kleankanteen.be";
        break;
      case 'ca':
        showModal = true;
        countryText = "Canada";
        redirect = "https://www.kleankanteen.com/pages/store-locator-canada";
        break;
      case 'cl':
        showModal = true;
        countryText = "Chile";
        redirect = "https://www.kleankanteen.cl";
        break;
      case 'cr':
        showModal = true;
        countryText = "Costa Rica";
        redirect = "https://www.kleankanteen.co.cr";
        break;
      case 'de':
        showModal = true;
        countryText = "Germany";
        redirect = "https://www.kleankanteen.de";
        break;
      case 'es':
        showModal = true;
        countryText = "Spain";
        redirect = "https://www.kleankanteen.es";
        break;
      case 'fr':
        showModal = true;
        countryText = "France";
        redirect = "https://www.kleankanteen.be";
        break;
      case 'gb':
        showModal = true;
        countryText = "Great Britain";
        redirect = "https://www.kleankanteen.co.uk";
        break;
      case 'ie':
        showModal = true;
        countryText = "Ireland";
        redirect = "https://www.kleankanteen.co.uk";
        break;
      case 'jp':
        showModal = true;
        countryText = "Japan";
        redirect = "https://www.kleankanteen.jp";
        break;
      case 'kr':
        showModal = true;
        countryText = "Korea";
        redirect = "https://www.kleankanteen.co.kr";
        break;
      case 'lu':
        showModal = true;
        countryText = "Luxembourg";
        redirect = "https://www.kleankanteen.be";
        break;
      case 'mx':
        showModal = true;
        countryText = "Mexico";
        redirect = "https://www.kleankanteen.com/pages/store-locator-mexico";
        break;
      case 'my':
        showModal = true;
        countryText = "Malaysia";
        redirect = "https://certifiedcalm.com/collections/klean-kanteen-1/Insulated-Bottle";
        break;
      case 'nz':
        showModal = true;
        countryText = "New Zealand";
        redirect = "https://www.kleankanteen.co.nz";
        break;
      case 'nl':
        showModal = true;
        countryText = "The Netherlands";
        redirect = "https://www.kleankanteen.be";
        break;
      case 'pt':
        showModal = true;
        countryText = "Portugal";
        redirect = "https://www.kleankanteen.es";
        break;
      case 'ph':
        showModal = true;
        countryText = "Philippines";
        redirect = "https://certifiedcalm.com/collections/klean-kanteen-1/Insulated-Bottle";
        break;
      case 'sg':
        showModal = true;
        countryText = "Singapore";
        redirect = "https://www.kleankanteen.com/pages/store-locator-singapore";
        break;
      case 'ru':
        showModal = true;
        countryText = "Russia";
        redirect = "https://www.kleankanteen.ru.com";
        break;
      case 'se':
        showModal = true;
        countryText = "Sweden";
        redirect = "https://www.kleankanteen.se";
        break;
      case 'th':
        showModal = true;
        countryText = "Thailand";
        redirect = "https://shopprogression.com/klean-kanteen";
        break;
      case 'tw':
        showModal = true;
        countryText = "Taiwan";
        redirect = "https://www.kleankanteentw.com";
        break;
      case 'uk':
        showModal = true;
        countryText = "United Kingdom";
        redirect = "https://www.kleankanteen.co.uk";
        break;
      default:
        showModal = true;
        notFoundText = "Unfortunately we don't have any featured online stores in your location.";
    }

    

    //show the modal
    if(showModal) {
      const country = document.getElementById("region-selector-country");
      if(country) {
        country.innerHTML = countryText;
      }

      const modal = document.getElementById("modal-region-selector");
      if(modal) {
        modal.setAttribute('aria-hidden', 'false');
      }

      if(notFoundText != "") {
        // no redirect
        const button = document.getElementById("region-selector-go");
        if(button) {
          button.remove();
        }

        const button2 = document.getElementById("region-selector-stay");
        if(button2) {
          button2.innerHTML = 'Close';
        }

        const txt = document.getElementById("region-selector-text");
        if(txt) {
          txt.innerHTML = notFoundText;
        }

      }
      else {
        // setup redirect
        
        const button = document.getElementById("region-selector-go");
        if(button) {
          button.setAttribute('href', redirect);
        }

        myTimeout =  setTimeout(function () {
            window.location.href = redirect;
        }, 7000); //will call the function after 5 secs.
      }
    }
    
  }

  var myTimeout = "";

  $('body').on('click','#region-selector-stay',function(e){
    console.log(myTimeout);
    clearTimeout(myTimeout);
    
    const modal = document.getElementById("modal-region-selector");
    if(modal) {
      modal.setAttribute('aria-hidden', 'true');
    }
  });
  
  //decide if the modal should be shown on page load
  showModalOnLoad();
  
  // //user can always change their region by clicking the flag
  // $(".site-nav__flag").on('click', function(evt) {
  //   regionModal.open(evt);
  // });
  
  // //user selects a region in the modal
  // $(".region-wrapper--content > a").on('click', function(evt) { 
  //   var clickedRegion = $(this).data('region');
  //   if(storeCode == clickedRegion) {
  //     //the user selected the current store
  //     evt.preventDefault();
  //     regionModal.close();
  //     //set the local storage
  //     window.localStorage.setItem(lsStorageKey, storeCode);
  //   }
  //   else {
  //     //allow click to proceed
  //   }
  // });

}
theme.regionModal();

// Cart sidebar thumbnail
function isArtworkItem (item) {
  var itemProps = Object.prototype.hasOwnProperty.call(item, 'properties') ? item.properties : null;
  if (!itemProps) {
    return false;
  }

  return (
    Object.prototype.hasOwnProperty.call(item, 'id') &&
    Object.prototype.hasOwnProperty.call(item, 'handle') &&
    Object.prototype.hasOwnProperty.call(itemProps, '_RecipeID') &&
    Object.prototype.hasOwnProperty.call(itemProps, '_Thumbnail')
  );
}

function getItemsWithArtwork (cartItems) {
  return cartItems.filter(isArtworkItem);
}

function getItemArtworkPaths (artworkItems) {
  return artworkItems.reduce(function (acc, next) {
    var data = {
      'handle': next.handle,
      'lookup': 'product-' + next.handle,
      'recipeID': next.properties['_RecipeID'],
      'thumbnail': next.properties['_Thumbnail']
    };

    acc[next.id] = data;

    return acc;
  }, {});
}

function updateCartThumbnail (thumbnailData) {
  Object.keys(thumbnailData).forEach(function (itemId) {
      var result = thumbnailData[itemId];
      var liImg = $('#rebuy-cart ul.rebuy-cart__flyout-items')
        .children('li.' + result.lookup + '.property-value-' + result.recipeID)
        .children('.rebuy-cart__flyout-item-media')
        .find('img');
    if (liImg.length) {
      liImg.attr('src', result.thumbnail);
    }
  });
}

function isUpChargeItem (item) {
  var itemProps = Object.prototype.hasOwnProperty.call(item, 'properties') ? item.properties : null;
  if (!itemProps) {
    return false;
  }

  return (
    Object.prototype.hasOwnProperty.call(item, 'id') &&
    Object.prototype.hasOwnProperty.call(item, 'handle') &&
    Object.prototype.hasOwnProperty.call(itemProps, 'RecipeID') &&
    Object.prototype.hasOwnProperty.call(itemProps, '_upcharge_parent_key')
  );
}

function getUpchargeParent(ucItem, cartItems) {
  return cartItems.find(function (cItem) {
    return (
      Object.prototype.hasOwnProperty.call(cItem, 'key') &&
      (cItem.key == ucItem.properties["_upcharge_parent_key"])
    );
  });
}

function getArtworkChild(acItem, cartItems) {
  return cartItems.find(function (cItem) {
    return (
      isUpChargeItem(cItem) &&
      (cItem.properties["RecipeID"] == "uc-" + acItem.properties["_RecipeID"])
    );
  });
}

function getRelatedCustomItem (item, cartItems) {
  if (isUpChargeItem(item)) {
    return getUpchargeParent(item, cartItems);
  }

  if (isArtworkItem(item)) {
    return getArtworkChild(item, cartItems);
  }

  return null;
}

function customItemsClicked () {
  var data = {};

  function hasClickedItem (item) {
    return (
      Object.prototype.hasOwnProperty.call(data, item.key)
    );
  }

  return {
    addItem: function (item) {
      data[item.key] = item;
    },
    getAllItems: function () { return data; },
    hasItem: hasClickedItem,
    getItem: function (item) {
      if (!hasClickedItem(item)) {
        return null;
      }

      return data[item.key];
    },
    removeItem: function (item) {
      if (!hasClickedItem(item)) {
        return;
      }

      var temp = Object.keys(data).reduce(function (acc, next) {
        if (item.key == next) {
          return acc;
        }

        acc[next] = data[next];
        return acc;
      }, {});

      data = temp;
    }
  };
}

var itemsClicked = customItemsClicked();

$(document).ready(function () {
  document.addEventListener('rebuy:smartcart.ready', function (evt) {
    var smCartInstance = evt.detail.smartcart;
    updateCartThumbnail(
      getItemArtworkPaths(
        getItemsWithArtwork(
          smCartInstance.items()
        )
      )
    );
    console.log(smCartInstance.items());
  });
  
  document.addEventListener('rebuy:cart.add', function (evt) {
    var smCartInstance = evt.detail.cart;
    updateCartThumbnail(
      getItemArtworkPaths(
        getItemsWithArtwork(
          smCartInstance.items()
        )
      )
    );
  });

  document.addEventListener("rebuy:smartcart.line-item-removed", function (evt) {
    var smCartInstance = evt.detail.smartcart;
    var itemRemoved = evt.detail.item;
    if (!isUpChargeItem(itemRemoved)) {
      return;
    }

    var parentItem = getUpchargeParent(itemRemoved, smCartInstance.items());
    if (!parentItem) {
      return;
    }

    smCartInstance.removeItem(parentItem);
  });

  document.addEventListener("rebuy:smartcart.line-item-increase", function (evt) {
    var smCartInstance = evt.detail.smartcart;
    var itemIncreased = evt.detail.item;
    var relatedItem = getRelatedCustomItem(itemIncreased, smCartInstance.items());
    if (!relatedItem) {
      return;
    }
    
    if ([relatedItem, itemIncreased].find(itemsClicked.hasItem)) {
      [relatedItem, itemIncreased].forEach(itemsClicked.removeItem);
      return;
    }
    
    itemsClicked.addItem(relatedItem);
    itemsClicked.addItem(itemIncreased);
    smCartInstance.increaseItem(relatedItem);
  });

  document.addEventListener("rebuy:smartcart.line-item-decrease", function (evt) {
    var smCartInstance = evt.detail.smartcart;
    var itemDecreased = evt.detail.item;
    var relatedItem = getRelatedCustomItem(itemDecreased, smCartInstance.items());
    if (!relatedItem) {
      return;
    }

    if ([relatedItem, itemDecreased].find(itemsClicked.hasItem)) {
      [relatedItem, itemDecreased].forEach(itemsClicked.removeItem);
      return;
    }
    
    itemsClicked.addItem(relatedItem);
    itemsClicked.addItem(itemDecreased);
    smCartInstance.decreaseItem(relatedItem);
  });
});